import React from 'react';
import { Drawer, Box, Typography, Link as MuiLink } from '@mui/material';

interface SidebarLayoutProps {
  open: boolean;
  onClose: () => void;
  topOffset?: number;
  title: string;
  onMoreDetails?: () => void;
  children: React.ReactNode;
}

/**
 * Common layout wrapper for right-anchored sidebars with a header.
 * Encapsulates the shared Drawer and header styling used across sidebars.
 */
const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  open,
  onClose,
  topOffset = 64,
  title,
  onMoreDetails,
  children,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '50vw',
          maxWidth: 900,
          p: 3,
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
          boxShadow: 6,
          mt: `${topOffset}px`,
          height: `calc(100% - ${topOffset}px)`,
          overflowY: 'auto',
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#f5831f' }}>
          {title}
        </Typography>

        {onMoreDetails && (
          <MuiLink
            component="button"
            onClick={onMoreDetails}
            sx={{
              color: '#f5831f',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '0.8rem',
              cursor: 'pointer',
            }}
          >
            More Details
          </MuiLink>
        )}
      </Box>

      {/* Body */}
      {children}
    </Drawer>
  );
};

export default SidebarLayout;
